import React from "react";

export const BestTimeTag = () => (
  // TODO: (nikita) replace hex color with DS token
  <span className="cw-bg-brand-emphasis cw-body-sm cw-text-[#054F3E] cw-ml-2 cw-px-2 cw-py-1 cw-rounded">
    BEST
  </span>
);
